  import {
    IComunixOcurrencyCodeEnum,
    IConsultStatusEnum,
  } from '../hooks/types/BatchConsults';
import { IDebts } from '../hooks/useDebts';

export const consultaNoDebtsCodes: IComunixOcurrencyCodeEnum[] = [
  IComunixOcurrencyCodeEnum.VEHICLE_IS_LICENSED,
  IComunixOcurrencyCodeEnum.NO_DEBTS_FOUND
]

export const consultaRunningStatuses: IConsultStatusEnum[] = [
  IConsultStatusEnum.IN_PROGRESS,
  IConsultStatusEnum.CONSULT_UPDATED
];

export function countSuccessfulAndFailedDebtConsults(
  consultas: {
    status: string;
    ocorrencia: string;
  }[],
) {
  const { successful, failed, successfulNoDebts } = consultas.reduce(
    (acc, consulta) => {
      if(consultaRunningStatuses.includes(consulta.status as IConsultStatusEnum)){
        return acc;
      }
    
      if(consulta.status === IConsultStatusEnum.INTEGRATOR_ERROR){

        const consultaHasNoDebt = consultaNoDebtsCodes.some(
          noDebtCode => consulta.ocorrencia.includes(
            noDebtCode.toLowerCase()
          )
        )
        if(consultaHasNoDebt) {
          acc.successfulNoDebts++
        } else{
          acc.failed++
        }
      } else{
        acc.successful++
      }

      return acc;
    },
    { successful: 0, failed: 0, successfulNoDebts: 0 },
  );

  return { successful, failed, successfulNoDebts };
}

export function getUniqueVehiclePlates(selectedDebts: IDebts[]) {
  const consultsPackage = selectedDebts.map((debt) => debt?.vehiclePlate);
  const uniquePlates = [...new Set(consultsPackage)];
  return uniquePlates;
};
  
